import { render } from "./FormCliente.vue?vue&type=template&id=2d57548e"
import script from "./FormCliente.vue?vue&type=script&lang=js"
export * from "./FormCliente.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__